import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=b36f3e28&scoped=true&"
import script from "./RolesManager.vue?vue&type=script&lang=js&"
export * from "./RolesManager.vue?vue&type=script&lang=js&"
import style0 from "./RolesManager.vue?vue&type=style&index=0&id=b36f3e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f3e28",
  null
  
)

export default component.exports